import { Badge } from "V2.0/common/badge";

export default NodeExecutionStatusBadge;

export { NodeExecutionStatus };

const NodeExecutionStatus = {
  PENDING: "pending",
  RUNNING: "running",
  COMPLETED: "completed",
  FAILED: "failed",
  SKIPPED: "skipped",
  WAITING: "waiting",
} as const;

const nodeExecutionStatusConfig = {
  [NodeExecutionStatus.COMPLETED]: { label: "Completed", color: "emerald" },
  [NodeExecutionStatus.FAILED]: { label: "Failed", color: "red" },
  [NodeExecutionStatus.PENDING]: { label: "Pending", color: "amber" },
  [NodeExecutionStatus.RUNNING]: { label: "Running", color: "amber" },
  [NodeExecutionStatus.SKIPPED]: { label: "Skipped", color: "purple" },
  [NodeExecutionStatus.WAITING]: { label: "Waiting", color: "amber" },
};

type NodeExecutionStatus =
  (typeof NodeExecutionStatus)[keyof typeof NodeExecutionStatus];

function NodeExecutionStatusBadge(props) {
  const { status } = props;

  const { label, color } = nodeExecutionStatusConfig[status] ?? {
    label: "status",
    color: "gray",
  };

  return (
    <div>
      <Badge color={color}>{label}</Badge>
    </div>
  );
}
